class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
      
      //Swym Loader
      document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
      
      function swymCallbackFn(swat){
        // your API calls go here
        document.addEventListener("swym:collections-loaded", function(){
          swat.initializeActionButtons("body");
        })
      }
      if(!window.SwymCallbacks){
        window.SwymCallbacks = [];
      }
      window.SwymCallbacks.push(swymCallbackFn);
      //console.log("Swym loaded");
  
      const totalProductsElement = document.getElementById('collectionProductCount');
      const totalProducts = totalProductsElement ? parseInt(totalProductsElement.textContent, 10) : 0;
    
      // Count visible products
      const products = document.querySelectorAll('.product-grid > li');
      const productCount = products.length;
    
      // Display the count somewhere if needed
      const countElement = document.getElementById('product-count');
      if (countElement) {
        countElement.textContent = `${productCount}`;
      }
    
      // Calculate percentage
      const percentage = totalProducts > 0 ? (productCount / totalProducts) * 100 : 0;
    
      // Update progress bar width
      const progressBar = document.getElementById('progress-bar');
      if (progressBar) {
        progressBar.style.width = `${percentage}%`;
      }

          var endlessScroll = new Ajaxinate({
      method: 'scroll', // Change to 'click' if you want a button instead
      container: '.product-grid',
      pagination: '#AjaxinatePagination',
      callback: function(){
        setTimeout(function() {
          const totalProductsElement = document.getElementById('collectionProductCount');
          const totalProducts = totalProductsElement ? parseInt(totalProductsElement.textContent, 10) : 0;
        
          // Count visible products
          const products = document.querySelectorAll('.product-grid > li');
          const productCount = products.length;
        
          // Display the count somewhere if needed
          const countElement = document.getElementById('product-count');
          if (countElement) {
            countElement.textContent = `${productCount}`;
          }
        
          // Calculate percentage
          const percentage = totalProducts > 0 ? (productCount / totalProducts) * 100 : 0;
        
          // Update progress bar width
          const progressBar = document.getElementById('progress-bar');
          if (progressBar) {
            progressBar.style.width = `${percentage}%`;
          }
          //Swym Loader
            document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
            
            function swymCallbackFn(swat){
              // your API calls go here
              document.addEventListener("swym:collections-loaded", function(){
                swat.initializeActionButtons("body");
              })
            }
            if(!window.SwymCallbacks){
              window.SwymCallbacks = [];
            }
            window.SwymCallbacks.push(swymCallbackFn);
            //console.log("Swym loaded Ajax");
        }, 200);
       
      }
      
    });


    const sortDeskButton = document.getElementById("sortDeskButton");
const sortDeskDropdown = document.getElementById("sortDeskDropdown");
const sortOptions = document.querySelectorAll("#sortDeskDropdown li");

let ajaxinateInitialized = false; // Track Ajaxinate state

// Get current URL parameters to highlight the selected option
const urlParams = new URLSearchParams(window.location.search);
const currentSort = urlParams.get("sort_by");

function updateURL(sortBy) {
  const url = new URL(window.location.href);
  url.searchParams.set("sort_by", sortBy);
  window.history.pushState({}, "", url); // Update the browser URL without refreshing
}

// Highlight the current sort option on page load
if (currentSort) {
  sortOptions.forEach(option => {
    if (option.getAttribute("data-sort") === currentSort) {
      option.classList.add("active-sort");
      sortDeskButton.textContent = `Sort By : ${option.textContent}`;
    }
  });
}

// Toggle dropdown on button click
sortDeskButton.addEventListener("click", function () {
  sortDeskDropdown.classList.toggle("sort-hidden");
});

// Close dropdown when clicking outside
document.addEventListener("click", function (event) {
  if (!sortDeskButton.contains(event.target) && !sortDeskDropdown.contains(event.target)) {
    sortDeskDropdown.classList.add("sort-hidden");
  }
});

// Sort option click handler
sortOptions.forEach(item => {
  item.addEventListener("click", function () {
    const selectedSort = this.getAttribute("data-sort");
    sortDeskDropdown.classList.add("sort-hidden");
    sortDeskButton.textContent = `Sort By : ${this.textContent}`;
    updateURL(selectedSort);

    sortOptions.forEach(option => option.classList.remove("active-sort"));
    this.classList.add("active-sort");

    const url = new URL(window.location.href);
    url.searchParams.set("sort_by", selectedSort);

    // Clear existing product grid before replacing with new sorted items
    const oldGrid = document.querySelector(".product-grid");
    if (oldGrid) {
      const newEmptyGrid = oldGrid.cloneNode(false); // clone structure without children
      oldGrid.parentNode.replaceChild(newEmptyGrid, oldGrid);
    }

    fetch(url)
      .then(response => response.text())
      .then(data => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, "text/html");

        const newProducts = doc.querySelector(".product-grid");
        const newPagination = doc.querySelector("#AjaxinatePagination");

        if (newProducts) {
          document.querySelector(".product-grid").innerHTML = newProducts.innerHTML;

          // Replace or update pagination
          const existingPagination = document.querySelector("#AjaxinatePagination");
          if (existingPagination) {
            existingPagination.remove();
          }

          if (newPagination) {
            const productGrid = document.querySelector(".product-grid");
            if (productGrid) {
              productGrid.insertAdjacentElement("afterend", newPagination);
            }
          }

          // Update product count and progress bar
          const totalProductsElement = document.getElementById('collectionProductCount');
          const totalProducts = totalProductsElement ? parseInt(totalProductsElement.textContent, 10) : 0;

          const products = document.querySelectorAll('.product-grid > li');
          const productCount = products.length;

          const countElement = document.getElementById('product-count');
          if (countElement) {
            countElement.textContent = `${productCount}`;
          }

          const percentage = totalProducts > 0 ? (productCount / totalProducts) * 100 : 0;
          const progressBar = document.getElementById('progress-bar');
          if (progressBar) {
            progressBar.style.width = `${percentage}%`;
          }

          document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
            
            function swymCallbackFn(swat){
              // your API calls go here
              document.addEventListener("swym:collections-loaded", function(){
                swat.initializeActionButtons("body");
              })
            }
            if(!window.SwymCallbacks){
              window.SwymCallbacks = [];
            }
            window.SwymCallbacks.push(swymCallbackFn);
            //console.log("Swym loaded Ajax");

          updateProductCount(productCount);

          // ✅ Reset and reinitialize Ajaxinate safely
          ajaxinateInitialized = false;

          setTimeout(() => {
            if (document.querySelector("#AjaxinatePagination a")) {
              initializeAjaxinate();
              //console.log("Ajaxinate reinitialized after sort");
            } else {
              //console.log("No pagination link — Ajaxinate not reinitialized");
            }
          }, 200);
        }
      })
      .catch(error => console.error("Error fetching sorted products:", error));
  });
});

function initializeAjaxinate() {
  if (ajaxinateInitialized) return;
  ajaxinateInitialized = true;

  new Ajaxinate({
    method: 'scroll',
    container: '.product-grid',
    pagination: '#AjaxinatePagination',
    callback: function () {
      setTimeout(() => {
        const currentCount = document.querySelectorAll(".product-grid .grid__item").length;
        updateProductCount(currentCount);
        // updateProductCountsText();
        const totalProductsElement = document.getElementById('collectionProductCount');
          const totalProducts = totalProductsElement ? parseInt(totalProductsElement.textContent, 10) : 0;

          const products = document.querySelectorAll('.product-grid > li');
          const productCount = products.length;

          const countElement = document.getElementById('product-count');
          if (countElement) {
            countElement.textContent = `${productCount}`;
          }

          const percentage = totalProducts > 0 ? (productCount / totalProducts) * 100 : 0;
          const progressBar = document.getElementById('progress-bar');
          if (progressBar) {
            progressBar.style.width = `${percentage}%`;
          }

        const nextLink = document.querySelector("#AjaxinatePagination a");
        if (!nextLink) {
          document.getElementById("AjaxinatePagination")?.remove();
          ajaxinateInitialized = false; // Reset for future scrolls
          //console.log("No more pages — scroll pagination removed.");
          //console.log("JS");
        }
        //Swym Loader
            document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
            
            function swymCallbackFn(swat){
              // your API calls go here
              document.addEventListener("swym:collections-loaded", function(){
                swat.initializeActionButtons("body");
              })
            }
            if(!window.SwymCallbacks){
              window.SwymCallbacks = [];
            }
            window.SwymCallbacks.push(swymCallbackFn);
            //console.log("Swym loaded Ajax");
      }, 200);
    }
  });
}

// Utility to update product count — define this if not already available
function updateProductCount(count) {
  const countElement = document.getElementById("product-count");
  if (countElement) {
    countElement.textContent = `${count}`;
  }
}

      
   
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
